/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{isDevEnvironment as n,devHostnames as t,adjustStaticAGOUrl as o}from"../../core/devEnvironmentUtils.js";function r(t){return n(t)}function e(n){n=n||globalThis.location.hostname;return[/^zrh-.+?\.esri\.com$/].concat(t).some((t=>null!=n?.match(t)))}function i(n,t){return o(n,t)}export{i as adjustStaticAGOUrl,r as isDevEnvironment,e as isTelemetryDevEnvironment};
